var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76mm",
    height: "76mm",
    viewBox: "0 0 76 76",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-12,-12)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fontVariationSettings: "normal",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000"
    },
    id: "path3069-6",
    cx: 50,
    cy: 50,
    r: 35,
    className: "UnoptimicedTransforms",
    transform: "matrix(1.0857143,0,0,1.0857143,-4.285714,-4.285714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3069",
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#808080",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000",
      stopOpacity: 1
    },
    className: "UnoptimicedTransforms",
    d: "m 50.040501,20.535775 c -8.944703,0 -13.483673,10.728333 -13.483673,20.235742 0,11.2266 4.238964,9.038595 4.238964,16.309966 0,9.038847 -14.844008,10.706719 -20.729797,11.014355 A 35,35 0 0 0 50.000044,84.999811 35,35 0 0 0 79.893636,68.164854 C 73.900215,67.848019 59.341851,66.204162 59.341851,57.654547 c 0,-7.549004 4.385561,-4.909605 4.385561,-16.781173 0,-9.580275 -4.281558,-20.337599 -13.686911,-20.337599 z",
    transform: "matrix(1.0857143,0,0,1.0857143,-4.285714,-4.285714)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b92e4f5f04b59bb80c932dfa302fcec4.svg";
export { ForwardRef as ReactComponent };